import { useEffect, useState } from "react";

export const useDynamicIndex = (itemsLength: number, time = 3000): number => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const isLastItem = index === itemsLength - 1;

      if (isLastItem) return setIndex(0);

      return setIndex((prevState) => prevState + 1);
    }, time);

    return () => {
      clearInterval(interval);
    };
  }, [index, itemsLength, time]);

  return index;
};
